// extracted by mini-css-extract-plugin
export default {"header":"ArchivedRow_header__fESrB","back":"ArchivedRow_back__w7tBs","icon":"ArchivedRow_icon__GWGzK","label":"ArchivedRow_label__cG8xQ","meta":"ArchivedRow_meta__oDFUo"};